import { observer } from "mobx-react-lite";

import { getActiveToolProgressLabel } from "../toolConfig";
import { VibeChatStore } from "../stores";
import { ComputerAgentDataStatus } from "../types";
import { getVibeStreamingStatusLine } from "../utils/vibeStatusLine";
import { PulseDot } from "../widgets/PulseDot";

export const StreamThinkingIndicator = observer(
  ({ isLoading, chatStore }: { isLoading: boolean; chatStore: VibeChatStore }) => {
    if (!isLoading || !chatStore.hasStreamingStarted) {
      return null;
    }
    if (chatStore.isReceivingEvents && !chatStore.showThinkingAfterToolCall) {
      return null;
    }
    const storeMessages = chatStore.messages;
    const lastMessage = storeMessages[storeMessages.length - 1];
    if (lastMessage?.computerAgent?.status === ComputerAgentDataStatus.RUNNING) {
      return null;
    }
    if (!lastMessage?.content && !chatStore.showThinkingAfterToolCall) {
      return null;
    }

    const inFlightLabel = getActiveToolProgressLabel(storeMessages);
    const line = getVibeStreamingStatusLine(inFlightLabel);
    return (
      <div className="my-0.5 flex items-center gap-2">
        <PulseDot variant="blue" isAnimated className="m-0.5" />
        <span className="text-xs text-gray-500">{line}</span>
      </div>
    );
  },
);
